import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GlExportFilesTabComponent } from './gl-export-files-tab/gl-export-files-tab.component';
import { GlExportHistoryTabComponent } from './gl-export-history-tab/gl-export-history-tab.component';
import { Select, Store } from '@ngxs/store';
import {
  GeneralLedgerState,
  GlResetState,
  GlTabChanged
} from '../../../state/GeneralLedgerState/GeneralLedger.state';
import { Observable } from 'rxjs';
import { GlSettingsTabComponent } from './gl-settings-tab/gl-settings-tab.component';
import { NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { first, map } from 'rxjs/operators';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'lib-general-ledger-export',
  templateUrl: './general-ledger-export.component.html',
  styleUrls: ['./general-ledger-export.component.css'],
  standalone: false
})
export class GeneralLedgerExportComponent implements OnInit, OnDestroy {
  @Select(GeneralLedgerState.getCurrentTab)
  active: Observable<number>;
  exportFilesPreselect: string;

  @ViewChild('nav') private tabs: NgbNav;

  //Only here to support some unit tests.
  @ViewChild('exportFilesTabComponent')
  exportFilesTab: GlExportFilesTabComponent;

  //Only here to support some unit tests.
  @ViewChild('exportHistoryTabComponent')
  exportHistoryTab: GlExportHistoryTabComponent;

  //Only here to support some unit tests.
  @ViewChild('exportSettingsTabComponent')
  exportSettingsTab: GlSettingsTabComponent;

  constructor(
    public modalService: ModalService,
    private store: Store
  ) {}

  ngOnInit() {}
  ngOnDestroy() {
    this.store.dispatch(new GlResetState());
  }

  changeId(id) {
    this.store.dispatch(new GlTabChanged(id));
  }

  // task #25894. when updating a GL setup, pop nav confirmation modal if unsaved changes exist
  onNavChange(evnt: NgbNavChangeEvent) {
    if (!this.exportSettingsTab?.exportFilesPrimary) {
      return;
    }

    this.exportSettingsTab.exportFilesPrimary.onDeactivate().subscribe(deactivate => {
      if (!deactivate) {
        // stop the current nav change event
        evnt.preventDefault();

        const msg = 'Are you sure you want to leave this page? Changes you made will not be saved.';
        this.modalService.showConfirmModal(msg, 'Cancel', 'Leave Page', 'Unsaved Changes');
        this.modalService.confirmModalCallback.pipe(first()).subscribe((confirm: boolean) => {
          if (confirm) {
            // user confirmed they want to lose unsaved changes.
            // switch to the tab the user clicked
            this.tabs.select(evnt.nextId);
          }
        });
      }
    });
  }
}
